module.exports = __webpack_public_path__ + "static/media/kelbuild.c589a705.png";